import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { TestimonialServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Product Master section
 */
const useListTestimonial = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ["testimonial-list", page_no],
    TestimonialServices.testimonialList,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};
const useAddTestimonial = (onSuccess, onError = onDefaultError) => {
  return useMutation(TestimonialServices.addTestimonial, {
    onSuccess,
    onError,
  });
};
const useUpdateTestimonial = (onSuccess, onError = onDefaultError) => {
  return useMutation(TestimonialServices.updateTestimonial, {
    onSuccess,
    onError,
  });
};
const useViewTestimonial = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "testimonial-view",
    () => TestimonialServices.viewTestimonial({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useTestimonialDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(TestimonialServices.deleteTestimonial, {
    onSuccess,
    onError,
  });
};
const useTestimonialStatusChange = (onSuccess, onError = onDefaultError) => {
  return useMutation(TestimonialServices.updateStatusTestimonial, {
    onSuccess,
    onError,
  });
};
export {
  useListTestimonial,
  useAddTestimonial,
  useUpdateTestimonial,
  useViewTestimonial,
  useTestimonialDelete,
  useTestimonialStatusChange,
};
